import React from "react";
import { fetchData } from "../components/misc";
import { Loader } from "../components/profile";
import { trackEvent } from "../utils/bridge.js";

export default function AiConversationsAdmin() {
    const [conversations, setConversations] = React.useState([])
    const [loading, setLoading] = React.useState(true)

    const loadConversations = React.useCallback(() => {
        setLoading(true)
        fetchData('/api/sirri_api/aiconversations').then((data) => {
            if (data.responsecode === 200) {
                trackEvent('admin_ai_conversations_loaded')
                setConversations(data.conversations || [])
            } else {
                alert("Something went wrong. Please contact support.")
            }
            setLoading(false)
        }).catch((error) => {
            console.error("Error fetching AI conversations:", error)
            setLoading(false)
        })
    }, [])

    React.useEffect(() => {
        loadConversations()
    }, [loadConversations])

    function stopConversation(filename) {
        trackEvent('admin_ai_conversation_stopped')
        fetch(`/api/sirri_api/aiconversations/${encodeURIComponent(filename)}`, {
            method: 'DELETE'
        }).then((response) => response.json())
            .then((data) => {
                if (data.responsecode === 200) {
                    setConversations((prev) => prev.filter((item) => item.filename !== filename))
                } else {
                    alert("Failed to stop conversation.")
                }
            }).catch((error) => {
                console.error("Error stopping conversation:", error)
                alert("Failed to stop conversation.")
            })
    }

    return (
        <div className="flex flex-col">
            <h1 className="text-white text-2xl mb-4">AI Conversations</h1>
            {loading
                ? <Loader />
                : <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    {conversations.length === 0
                        ? <p className="text-white">No active conversations found.</p>
                        : conversations.map((conversation) => {
                            const info = conversation.data || {}
                            return (
                                <div className="bg-black text-white w-full flex flex-col rounded-lg p-4" key={conversation.filename}>
                                    <div className="flex justify-end">
                                        <details className="relative">
                                            <summary className="cursor-pointer text-xl list-none">⋮</summary>
                                            <div className="absolute right-0 mt-2 w-40 rounded bg-white text-black shadow-lg z-10">
                                                <button
                                                    className="w-full px-3 py-2 text-left hover:bg-gray-200"
                                                    onClick={() => stopConversation(conversation.filename)}
                                                >
                                                    Stop Conversation
                                                </button>
                                            </div>
                                        </details>
                                    </div>
                                    <p className="text-lg font-semibold">{info.malename || "Unknown man"}</p>
                                    <p>Woman Email: {info.woman_email || "Unknown"}</p>
                                    <p>Woman ID: {info.woman_id || "Unknown"}</p>
                                    <p className="text-sm text-gray-300">File: {conversation.filename}</p>
                                </div>
                            )
                        })}
                </div>
            }
        </div>
    )
}
